import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "detail",
  "use": "detail-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"detail\"><defs><style></style></defs><path d=\"M816 64h-80v64h80c26.5 0 48 21.5 48 48v672c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h80V64h-80c-61.8 0-112 50.2-112 112v672c0 61.8 50.2 112 112 112h608c61.8 0 112-50.2 112-112V176c0-61.8-50.2-112-112-112z\" /><path d=\"M384 64h256v64H384zm-96 320h448v64H288zm0 224h288v64H288z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol